import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import { type IFetchReportPayload, type IReportRequest, ReportRequestName } from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchScheduledReports(action: IActionWithPayload<string, IFetchReportPayload>): any {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.ScheduledReports,
      interface: ApiManager.exportApi.fetchScheduledReports,
      disableComparison: true,
    },
  ];

  yield makeFetchingSaga(ReportType.ScheduledReports, action, requests);
}
